"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalVariableServiceWorkerTemplate = void 0;
function GlobalVariableServiceWorkerTemplate() {
    return 'const that = typeof global === \'object\' ? global : this;';
}
exports.GlobalVariableServiceWorkerTemplate = GlobalVariableServiceWorkerTemplate;
